'use client';

import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';

export function HorizontalSlider({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',
  });

  return (
    <div ref={emblaRef} className={cn('overflow-hidden', className)}>
      <div className="flex gap-12">{children}</div>
    </div>
  );
}
